/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'stellar_body/technological_factor': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M14 9.906c-.437 0-.837.145-1.166.381l-1.802-1.496c.333-.482.53-1.066.53-1.697 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.094.595 2.043 1.471 2.566l-.835 2.266c-.066-.006-.131-.02-.198-.02a2 2 0 102 2c0-.681-.342-1.28-.862-1.642l.823-2.231a2.976 2.976 0 002.368-.526l1.867 1.551a1.963 1.963 0 00-.196.848 2 2 0 102-2zm-5.437-.812c-1.103 0-2-.896-2-2s.897-2 2-2 2 .896 2 2-.898 2-2 2z"/>'
  }
})
